// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__20da6","buttons":"RemoveExpirationActionButtons_buttons__3CBun"};